<template>
    <div class="div tooltip" :data-tooltip="carData.query.port_of_arrival">
        <button class="button is-small text-button" :class="{'bold' : isFilled}" @click="openModal" style="min-width: 55px;">
            {{ carData.query.port_of_arrival }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Port of Arrival: {{ carData.query.port_of_arrival }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                        <tr>
                            <th width="10">Select</th>
                            <th>Name</th>
                            <th width="10">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(port, index) in ports">
                            <td width="10">
                                <button class="button is-info" @click="selectPort(port.name)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                </button>
                            </td>
                            <td class="subtitle">{{ port.name }}</td>
                            <td width="10">
                                <button class="button is-danger" @click="deletePort(index, port)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input v-model="newPort.name" class="input" type="text" placeholder="Type name of the port">
                            </td>
                            <td width="10">
                                <button class="button is-primary" @click="createNewPort">
                                        <span class="icon">
                                              <i class="fas fa-save"></i>
                                            </span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiPortsOfArrival from './../../../api/apiPortsOfArrival'
    import apiCars from './../../../api/apiCars'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                isActive: false,
                ports: [],
                carData:{
                    id: this.car.id,
                    query: {
                        port_of_arrival: this.car.port_of_arrival === null ? '---' : this.car.port_of_arrival,
                    }
                },
                newPort: {
                    name: ''
                }
            }
        },
        methods: {
            createNewPort(){
                apiPortsOfArrival
                    .createPortOfArrivalRequest(this.newPort)
                    .then((response) => {
                        this.ports.push(response.data)
                        this.newPort.name = ''
                    })
                    .catch(error => console.log(error))
            },
            selectPort(name) {
                this.carData.query.port_of_arrival = name
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            },
            deletePort(index, port){
                apiPortsOfArrival
                    .deletePortOfArrivalRequest(port.id)
                    .then((response) => {
                        this.ports = this.ports.filter(item => item !== port)
                        this.newPort.name = ''
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
                apiPortsOfArrival
                    .portsOfArrivalListRequest()
                    .then((response) => {
                        this.ports = response.data
                    })
                    .catch(error => console.log(error))
            }
        },
        computed: {
            isFilled() {
                if (this.carData.query.port_of_arrival !== '---'){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .text-button {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/PortOfArrivalColumn.vue